// https://tc39.es/ecma262/#sec-expanded-years
const hasNonExpandedYear = (date: Date) => {
    const fullYear = date.getFullYear();
    return fullYear >= 0 && fullYear <= 9999;
};

export default hasNonExpandedYear;
